export const sortJoin = (A, B, Delim) => {
  return A < B ? A + Delim + B : B + Delim + A;
};
